<template>
    <div class="user-list">
        <div class="table-info">
            <div class="breadcrumb">
            <span>位置：</span>
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>系统设置</el-breadcrumb-item>
                <el-breadcrumb-item>会议室管理</el-breadcrumb-item>
            </el-breadcrumb>
            </div>
            <h3>会议室管理</h3>
        </div>
        <div class="table-content">
            <div class="tool-bar">
                <span>关键字：</span>
                <el-input v-model="keyword"  size="small" placeholder="请输入" width="264" class="key-word"></el-input>
                <span>状态：</span>
                <el-select v-model="status" size="small" class="status">
                  <el-option v-for="item in statuses"
                             :key="item.status"
                             :label="item.status"
                             :value="item.value">
                  </el-option>
                </el-select>
                <el-button type="primary" size="small" @click="getData()" v-if="isCompleted && isShowButton('查询')">查询</el-button>
                <el-button size="small" @click="resetData()" v-if="isCompleted && isShowButton('重置')">重置</el-button>
                <el-button size="small" type="primary" @click="handleOption('新增')" v-if="isCompleted && isShowButton('新增会议室')">新增会议室</el-button>
            </div>
             <el-table
                :data="tableData5"
                v-loading="loading"
                stripe
                style="width: 100%">
                <el-table-column
                  label="会议室名称"
                  prop="boardroomName" align="center">
                </el-table-column>
                <el-table-column
                  label="账户名称"
                  prop="userName" align="center">
                </el-table-column>
                <el-table-column
                  label="API Key"
                  prop="apI_Key" align="center">
                </el-table-column>
                <el-table-column
                  label="API Secret"
                  prop="apI_Secret" align="center">
                </el-table-column>

               <el-table-column
                 label="zcode"
                 prop="zcode" align="center">
               </el-table-column>
               <el-table-column
                 label="分配情况"
                 prop="isFree" align="center">
               </el-table-column>

                <el-table-column
                  label="状态"
                  width="80"
                  prop="status" align="center">
                </el-table-column>
                <el-table-column
                  label="到期时间"
                  align="center"
                  >
                  <template slot-scope="scope">
                    <span v-if="isExpire(scope.row.expireDate)" style="color: red" title="会议室快到期了，请提醒用户充值">{{scope.row.expireDate | date}}</span>
                    <span v-else>{{scope.row.expireDate | date}}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作" align="center">
                  <template slot-scope="scope">
                      <el-button type="text" @click="handleOption('编辑',scope.row)">编辑</el-button>
                      <!-- <el-button type="text" @click="ceshi(scope.row.startUrl)">测试</el-button> -->
                    <el-popover
                      placement="top"
                      width="172"
                      v-model="scope.row.isAbolish">
                      <p><i class="el-icon-error" style="color:red;"></i>该操作不可逆,是否确认？</p>
                      <div style="text-align: right; margin: 0">
                        <el-button size="mini" type="text" @click="scope.row.isAbolish = false">取消</el-button>
                        <el-button type="primary" size="mini" @click="scope.row.isAbolish = false,del(scope.row.id)">确定</el-button>
                      </div>
                      <el-button class="marginLeft10" slot="reference" type="text">删除</el-button>
                    </el-popover>
                  </template>
                </el-table-column>
            </el-table>
          <el-pagination @size-change='handleSizeChange' @current-change='handleCurrentChange' :current-page.sync='PageIndex' :page-sizes='[10, 20, 50]'
                         :page-size='PageSize' layout='total, sizes, prev, pager, next, jumper' :total='total'>
          </el-pagination>
        </div>
        <!-- 新增会议室 zcode  会议室密码（可填） 新增开始时间(必须) 去掉状态  添加时间改为开始时间-->
        <el-dialog :title="title" :visible.sync="dialogShow" :before-close="handleClose">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-row>
                <el-col class="title" :span="4">会议室名称：</el-col>
                <el-col :span="8">
                  <el-form-item prop="boardroomName">
                    <el-input size="mini" v-model="ruleForm.boardroomName"></el-input>
                  </el-form-item>
                </el-col>
              <el-col class="title" :span="4">账户名称：</el-col>
              <el-col :span="8">
                <el-form-item prop="userName">
                  <el-input size="mini" v-model="ruleForm.userName"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
                <el-col class="title" :span="4">zcode：</el-col>
                <el-col :span="8">
                  <el-form-item prop="zcode">
                    <el-input size="mini" v-model="ruleForm.zcode"></el-input>
                  </el-form-item>
                </el-col>
                <el-col class="title" :span="4">API key：</el-col>
                <el-col :span="8">
                  <el-form-item prop="apI_Key">
                    <el-input size="mini" v-model="ruleForm.apI_Key"></el-input>
                  </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col class="title" :span="4">API secret：</el-col>
                <el-col :span="8">
                  <el-form-item prop="apI_Secret">
                    <el-input size="mini" v-model="ruleForm.apI_Secret"></el-input>
                  </el-form-item>
                </el-col>
                <el-col class="title" :span="4">到期时间：</el-col>
                <el-col :span="8">
                  <el-form-item prop="expireDate">
                    <el-date-picker
                      v-model="ruleForm.expireDate"
                      type="date"
                      :picker-options="pickerOptions0"
                      placeholder="选择到期时间">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
            </el-row>
            <!-- <el-row>
              <el-col class="title" :span="4">密码：</el-col>
              <el-col :span="8">
                <el-form-item prop="password">
                  <el-input size="mini" v-model="ruleForm.password"></el-input>
                </el-form-item>
              </el-col>
            </el-row> -->
          </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogShow = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit('ruleForm')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import moment from 'moment'
import isShowButton from '@/mixins'
export default {
  mixins: [isShowButton],
    data () {
    return {
      loading: true,
      isCompleted: false, //是否请求完成
      btnPremissionList: [],
      menuId: this.$route.query.menuId,

      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      nowDate:new Date(moment(new Date()).format('YYYY-MM-DD')),
      PageIndex:1, //当前页
      PageSize:10, //每页数量
      totalCache:0, //条数
      title:'',
      keyword:'',
      currentIndex: "",
      // 新增会议室
      dialogShow: false,
      //未开始，进行中，已结束
      statuses:[
      {status: "进行中",value:2},
      {status: "未开始",value:1},
      {status: "已结束",value:3}
      ],
      status:'',
      initForm:{
        id: '',
        boardroomName: '',
        status: '',
        userName: '',
        apI_Key: '',
        apI_Secret: '',
        createdTime: '',
        zcode:'',
        expireDate:'',
        // password:''
      },
      ruleForm:{},
      // 编辑会议室
      rules: {
        boardroomName: [{required:true,message:'请输入会议室名称',trigger:'blur'},{max:20,message:'不能超过20个字符'}],
        zcode: [{required:true,message:'请输入zcode',trigger:'blur'},{max:50,message:'不能超过50个字符'}],
        userName: [{required:true,message:'请输入账户名称',trigger:'blur'},{max:50,message:'不能超过50个字符'}],
        apI_Key: [{required:true,message:'请输入APIkey',trigger:'blur'},{max:50,message:'不能超过50个字符'}],
        apI_Secret: [{required:true,message:'请输入APIsecret',trigger:'blur'},{max:50,message:'不能超过50个字符'}],
        expireDate: [{required:true,message:'请选择开始时间',trigger:'blur'}],
      },
      status: null,
      tableData5: []
    }
    },
    filters: {
      date(value) {
        value = moment(value).format('YYYY-MM-DD')
        return value
      }
    },
    methods: {
      isExpire(val){
        let expireDate= new Date(moment(val).format('YYYY-MM-DD'))
        if(parseInt((expireDate-this.nowDate)/(1000 * 60 * 60 * 24)) < 7){
          return true
        }else{
          return false
        }
      },
      handleClose(done){
        this.$confirm('关闭后信息不能保存,是否退出？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      resetData(){
        this.status=''
        this.keyword=''
        this.getData();
      },
      handleSizeChange(val) {
        this.PageSize = val
        this.getData()
      },
      handleCurrentChange(val) {
        this.PageIndex = val
        this.getData()
      },
      //新增、编辑操作
      handleOption(option,val){
        this.ruleForm={}
        if(option==='新增'){
          this.title='新增会议室'
          this.dialogShow=true
          this.ruleForm=this.initForm
        }else if(option==='编辑'){
          this.title='编辑会议室'
          this.dialogShow=true
          this.ruleForm=val
          this.ruleForm.statuses= [
            {status: "正常"},
            {status: "过期"},
            {status: "停用"}
          ]
        }
      },
      handleSubmit (formName) {
        this.$refs[formName].validate((valid) => {
          if(valid) {
            if(this.title === '新增会议室'){
              let test={
                boardroomName:this.ruleForm.boardroomName,
                userName:this.ruleForm.userName,
                apI_Key:this.ruleForm.apI_Key,
                apI_Secret:this.ruleForm.apI_Secret,
                ExpireDate:this.ruleForm.expireDate,
                zcode:this.ruleForm.zcode,
                password:this.ruleForm.password
              }
              this.Axios.post('/api/Boardroom/AddBoardroom',test).
                then(res=> {
                  if(res.data.status === 100){
                  this.$message({
                    showClose: true,
                    message: '添加成功',
                    type: 'success'
                  });
                }else if(res.data.status === 103){
                  this.$message({
                    showClose: true,
                    message: '重复添加',
                    type: 'error'
                  });
                }
                this.dialogShow=false
                this.$refs[formName].resetFields();
                this.getData();
              }).catch(function (error) {
                this.$message({
                  showClose: true,
                  message: '网络错误！联系管理员',
                  type: 'error'
                });
              })
            }else if(this.title==='编辑会议室'){
              // this.ruleForm.startTime='2018-08-10 10:00:00'
              let test={
                boardroomName:this.ruleForm.boardroomName,
                userName:this.ruleForm.userName,
                apI_Key:this.ruleForm.apI_Key,
                apI_Secret:this.ruleForm.apI_Secret,
                ExpireDate:this.ruleForm.expireDate,
                zcode:this.ruleForm.zcode,
                password:this.ruleForm.password
              }
              this.Axios.put('/api/Boardroom/UpdateBoardroom?id='+this.ruleForm.id,test).
              then(res=> {
                this.$message({
                  showClose: true,
                  message: '修改成功',
                  type: 'success'
                });
                this.dialogShow=false
                this.$refs[formName].resetFields();
                this.getData();
              }).catch(function (error) {
                this.$message({
                  showClose: true,
                  message: '网络错误！联系管理员',
                  type: 'error'
                });
              })
            }
          } else {
            return false
          }
        })
      },
      //根据条件获取会议室列表信息
      getData(){
        const conditions={
            pageindex: this.PageIndex,
            pagesize: this.PageSize,
        }
        if(this.status!=''){
            conditions.status=this.status
        }
        if(this.keyword!=''){
            conditions.keyword=this.keyword
        }
        this.loading = true
        this.Axios.post('/api/Boardroom/SearchBoardroomInfo',{data:conditions})
          .then( res => {
            const data=res.data
            if(data.status === 100){
              this.tableData5 = data.data.ret
              this.totalCache = data.data.total
              this.loading = false
            }else if(data.status === 102){
              this.tableData5=[]
              this.loading = false
            }
          }).catch(function (error) {
            this.$message({
              showClose: true,
              message: '网络错误！联系管理员',
              type: 'error'
            });
        })
      },
      del(id){
          this.Axios.delete("/api/Boardroom/DeleteBoardroom",{params:{id:id}}).then(res=>{
              if(res.data.status===100){
                this.$message({
                  showClose: true,
                  message: '删除成功!',
                  type: 'success'
                });
                this.getData();
              }else if(res.data.status===102){
                this.$message({
                  showClose: true,
                  message: '删除失败,该会议室被单位占用！',
                  type: 'error'
                });
              }else{
                this.$message({
                  showClose: true,
                  message: '内部错误!',
                  type: 'error'
                });
              }
          }).catch(error=>{
            this.$message({
              showClose: true,
              message: '网络错误！联系管理员',
              type: 'error'
            });
          })
      },
      // ceshi(url){
      //   window.open(url)
      // }
    },
    created(){
      this.getBtnRole()
      this.getData()
    },
  computed: {
    total() {
      return this.totalCache
    }
  }
}
</script>

<style scoped lang="less">
    .user-list{
        .breadcrumb{
            overflow:hidden;
            span,.el-breadcrumb{
                float:left;
            }
            span{
                font-size:14px;
                color:#666;
                line-height:1;
            }
        }
        .table-content{
            .tool-bar{
                padding:0 20px;
                span{
                    font-size:14px;
                    color:rgba(0,0,0,0.85);
                    font-weight:400;
                }
                .key-word,.status{
                    width:264px;
                    margin-right:40px;
                }
            }
            .el-table{
                margin:20px 0;
                a{
                    padding-right:15px;
                }
            }
            .el-pagination{
                /deep/ .number, /deep/ .btn-prev, /deep/ .btn-next{
                    background-color:#fff;
                    border:1px solid #d9d9d9;
                    width:32px;
                    height:32px;
                }
            }
        }
        .el-dialog__wrapper{
            /deep/ .el-dialog{
                width:770px;
            }
            .el-row{
                padding:15px;
                .title{
                    text-align:right;
                    padding-top:10px;
                }
            }
            .el-input, .el-select{
                width:206px;
            }
            /deep/ .el-dialog__header{
                border-bottom:1px solid #d9d9d9;
            }
            /deep/ .el-dialog__footer{
                border-top:1px solid #d9d9d9;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/SystemSet/BoardroomManage.vue